// The school crest is bundled as a static asset (not loaded from any external
// CDN) so it's guaranteed to render offline and after any redeploy.
import schoolLogo from "@/assets/school-logo.png";

export const LOGO_URL = schoolLogo;

export const SCHOOL_NAME = "Carmel Senior Secondary School";
export const SCHOOL_LOCATION = "Sri Vijaya Puram";
export const SCHOOL_MOTTO = "Rooted in God, Transform Lives";
export const SCHOOL_TAGLINE = "Enlighten · Empower · Excel";
